import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

// This page is a legacy redirect — new reset flow is at /reset-password-screen?token=...
export default function ResetPassword() {
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate('/forgot-password-screen', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 flex items-center justify-center p-4">
      <div className="text-center">
        <p className="text-slate-400 text-sm font-body">Redirecting...</p>
        <Link to="/forgot-password-screen" className="text-teal-400 text-sm mt-2 inline-block">
          Click here if not redirected
        </Link>
      </div>
    </div>
  );
}
